import Footer from "Components/Common/Footer/Footer";
import Header from "Components/Common/Header/Header";
import UserList from "Components/Common/UserList/List/UserList";

const Speakers = () => {
  const eventId = localStorage.getItem("eventId");

  return (
    <>
      <Header moduleName={"speakers"} />
      <section className="inner_sec">
        <div className="container">
          <UserList
            eventId={eventId}
            showTitle={true}
            componentName={"speakers"}
          />
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Speakers;
